import React, { Fragment } from 'react';
import { compose } from "redux";
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { withStyles } from "@material-ui/styles";
import { styles } from "../../layout/Layout.styles";
import Paper from '@material-ui/core/Paper';
import { theme } from "../../layout/Layout.theme";
import * as SELECTORS from "../../../redux/Redux.selectors";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import Typography from '@material-ui/core/Typography';
import Select from "@material-ui/core/Select/Select";
import { setSelectedDevotionalGroup } from "../../../redux/Redux.actions";

const mapStateToProps = state => {
  return ({
    selectedDevotionalGroupId: SELECTORS.selectedDevotionalGroupIdSelector(state),
    sortedDevotionalGroupsByGroupName: SELECTORS.sortedDevotionalGroupsByGroupNameSelector(state),
  });
};

const mapDispatchToProps = dispatch => ({
  dispatchSetSelectedDevotionalGroup: val => dispatch(setSelectedDevotionalGroup(val)),
});

class Admin extends React.Component {
  handleSelectChange(e) {
    const { value } = e.target;
    this.props.dispatchSetSelectedDevotionalGroup(value);
  }

  render () {
    const {
      classes,
      selectedDevotionalGroupId,
      sortedDevotionalGroupsByGroupName,
    } = this.props;

    return (
      <Fragment>
        <div style={{
          margin: '50px',
          height: '200px',
          width: '200px',
        }}>
          <Paper
            style={{
              padding: '20px',
              height: '100px',
              width: '400px',
          }}>
            <Typography className={classes.title} variant="body1" noWrap>
              {`View Participation By Devotional Group`}
            </Typography>
            <Select
              className={classes.selectContainer}
              value={selectedDevotionalGroupId}
              displayEmpty
              onChange={e => this.handleSelectChange(e)}
            >
              {sortedDevotionalGroupsByGroupName.map((group, i) => {
                return <MenuItem
                  key={i}
                  className={classes.selectOption}
                  value={group.id}>
                    {group.groupName}
                </MenuItem>
              })}
            </Select>
          </Paper>
        </div>
        <div style={{
          height: '200px',
          width: '200px',
        }}>
        </div>
      </Fragment>
    )
  }
}

export default compose(
  firestoreConnect(['devotionalGroups', 'devotees']),
  connect(mapStateToProps, mapDispatchToProps),
)(
  withStyles(
    styles,
    {
      defaultTheme: theme,
      withTheme: true,
      name: 'layout',
    }
  )(Admin));
